<template>
    <div class="animated slideInRight">
        <div class="mb-0">
            <div class="row flex-row">
                <div class="col-md-6">
                    <div class="card shadow-sm">
                        <img src="/static/images/label.png" alt="Label Image" class="card-img-top shadow-sm">
                        <div class="card-body">
                            <h4 class="pb-2 pt-2">Label(s)</h4>
                            <p >This is your copy of label. Print this off and attach it to you items.</p>
                        </div>
                        <template v-if='!printableConsignmentLoading'>
                            <a :href="printableConsignmentUrl" target="_blank" v-on:click="printableConsignmentUrlHasBeenClicked = true"
                            class="card-footer btn btn-secondary btn-lg">
                                <i class="fa fa-print mr-1"></i>
                                <span>Print Your Label</span>
                            </a>
                        </template>

                        <template v-else>
                            <div class='card-footer' style='height:56px'><span class='loader'></span></div>
                        </template>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="card shadow-sm">
                        <img src="/static/images/manifest.png" alt="Manifest Image" class="card-img-top shadow-sm">
                        <div class="card-body">
                            <h4 class="pb-2 pt-2">Manifest</h4>
                            <p >This is your manifest. Please provide this to the driver upon pickup.</p>
                        </div>
                        <template v-if='!printableManifestLoading'>
                            <a :href="printableManifestUrl" target="_blank" v-on:click="printableManifestUrlHasBeenClicked = true"
                            class="card-footer btn btn-secondary btn-lg">
                                <i class="fa fa-print mr-1"></i>
                                <span>Print Your Manifest</span>
                            </a>

                            <a v-if="printableDgUrl" :href="printableDgUrl" target="_blank" v-on:click="printableDgHasBeenClicked = true"
                            class="card-footer btn btn-secondary btn-lg">
                                <i class="fa fa-print mr-1"></i>
                                <span>Print Your Dangerous Goods Paperwork</span>
                            </a>
                        </template>
                        <template v-else>
                            <div class='card-footer' style='height:56px'><span class='loader'></span></div>
                        </template>
                    </div>
                </div>
                <div class="row card-body">
                    <div class="col">
                        <button class="btn btn-primary float-right" v-on:click="tryGoToNextStep" :disabled="!(printableManifestUrlHasBeenClicked && printableConsignmentUrlHasBeenClicked && (printableDgUrl ? printableDgHasBeenClicked : true))">Continue</button>
                        <button class="btn btn-danger float-right mr-2" v-on:click="goToRoot">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Step from '@/mixins/step'
export default {
  mixins: [Step],
  name: 'StepPrint',
  props: [],
  data () {
    return {
      printableManifestUrl: null, // The manifest PDF url
      printableConsignmentUrl: null, // The consignment PDF url
      printableManifestUrlHasBeenClicked: false, // We track whether they've pressed the print buttons
      printableManifestLoading: false,
      printableConsignmentUrlHasBeenClicked: false, // We track whether they've pressed the print buttons
      printableConsignmentLoading: false,
      printableDgUrl: null,
      printableDgHasBeenClicked: false,
      printableDgLoading: false
    }
  },
  created: function () {
    // When this step is created we want to load the data
    this.makeGetPrintableReturnConsignmentPublicRequest()
    this.makeGetPrintableReturnManifestPublicRequest()
  },
  methods: {
    /**
     * Make GetPrintableReturnConsignmentPublic Request
     *
     * This runs the request which retrieves the PDF's related to the consignment
     */
    makeGetPrintableReturnConsignmentPublicRequest: function () {
      this.printableConsignmentLoading = true
      // On the page load we load the config
      this.$http.post('/', {
        request: 'GetPrintableReturnConsignmentPublic',
        consignment: this.state.consignmentData.consignment,
        label_type: 'PDF',
        return: this.state.consignmentReturnCode
      }).then(response => {
        // Check if there's any errors
        if (!this.state.messages.check200ResponseForErrors(response.data)) {
          // Store the response
          this.state.printableConsignmentData = response.data
          this.printableConsignmentUrl = window.atob(response.data.label_pdf)

          if (response.data.dg_pdf) {
            this.printableDgUrl = window.atob(response.data.dg_pdf)
          }
        }

        this.printableConsignmentLoading = false
      }).catch(e => {
        this.printableConsignmentLoading = false
        this.state.messages.addErrorsFrom400Response(e)
      })
    },
    /**
     * Make GetPrintableReturnManifestPublic Request
     *
     * This runs the request which retrieves the PDF's related to the manifest
     */
    makeGetPrintableReturnManifestPublicRequest: function () {
      this.printableManifestLoading = true
      // On the page load we load the config
      this.$http.post('/', {
        request: 'GetPrintableReturnManifestPublic',
        manifest: this.state.consignmentIsManifested ? this.state.consignmentData['manifest_name'] : this.state.manifestData.manifest[0], // If is manifested use the name, if not use the manifest data
        return: this.state.consignmentReturnCode
      }).then(response => {
        this.printableManifestLoading = false
        // Check if there's any errors
        if (!this.state.messages.check200ResponseForErrors(response.data)) {
          // Store the response
          this.state.printableManifestData = response.data
          this.printableManifestUrl = window.atob(response.data.manifest_pdf)
        }
      }).catch(e => {
        this.printableManifestLoading = false
        this.state.messages.addErrorsFrom400Response(e)
      })
    },
    /**
     * Try Go To Next Step
     *
     * Ensure they've printed before we continue
     */
    tryGoToNextStep: function () {
      this.state.messages.clearMessages()
      if (this.printableManifestUrlHasBeenClicked && this.printableConsignmentUrlHasBeenClicked && (this.printableDgUrl ? this.printableDgHasBeenClicked : true)) {
        this.goToNextStep()
      } else {
        this.state.messages.addMessage('Please print Manifest and Consignment before continuing.', 0)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.has-custom-centered {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}
</style>
